<div>
  <div class="transalte-box">
    <div class ="translation-fields">
      <div class="sourceText">
        <mat-form-field>
          <mat-label>{{'FileUpload.Languages' | translate }}</mat-label>
          <mat-select [(ngModel)]="selectedSourceLanguage">
            @for (key of sourceLanguages| async | keyvalue; track key) {
              <mat-option [value]="key.value">
                {{key.key}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <textarea class="form-control" type="text" title="Input field" [(ngModel)]="textToTranslate" [placeholder]="'Text.EnterText' | translate" ></textarea>
      </div>
      <div class="buttonBetween">
        <button class="btn btn-primary" type="button" title="swapButton" (click)="SwapTranslatedText()"><i class="bi bi-arrow-left-right"></i></button>
      </div>
      <div class="targetText">
        <mat-form-field>
          <mat-label>{{'FileUpload.Languages' | translate }}</mat-label>
          <mat-select [(ngModel)]="selectedTargetLanguage">
            @for (key of targetLanguages | async | keyvalue; track key) {
              <mat-option [value]="key.value">
                {{key.key}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <textarea class="form-control" type="text" #copyText title="Input field" [readOnly]="true" [value] ="translatedtext"></textarea>
        <div class="copyTransferRow">
          <div class="copyButton">
            <button (click)="copyToClipboard()" class="btn btn-secondary btn-lg" type="button" title="Copy to clipboard"><i class="bi bi-clipboard"></i></button>
          </div>
          <div class="transferButton">
            <button (click)="transferToRephrase()" [disabled]="!translatedtext" class="btn btn-secondary btn-lg" type="button" title="Transfer to rephrase">{{'Text.TransferToRephrase' | translate}}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="translateButton">
      <button class="btn btn-primary" type="button" (click)="translateString()">{{'FileUpload.Translate' | translate}}</button>
    </div>
    <div class ="translateOptions">
      <app-translation-options></app-translation-options>
    </div>
  </div>
</div>
